document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("[data-product-page]")) {
        import(/* webpackChunkName: "product-page" */ "/Features/Products/Common/js/product-page.js").then(async (module) => {
            new module.default();
        });
    }
});